require('sass/brands/locations.firstinterstatebank.com/directory/default.scss');
require('js/locationList-script.js');
